import { Injectable } from '@angular/core';
import { CountlyService } from '../../../../../../helpers-v1';
import { SessionService } from '../../../../../../angular-services-v8/session.service';

@Injectable()
export class CountlyEvents {
  constructor(
    private countlyService: CountlyService,
    private sessionService: SessionService
  ) {}

  public onChangeForAnalytics(eventName, optionId) {
    const event = this.createEvent(eventName, optionId );
    this.countlyService.addBulkVariables(event);
  }

  /**
   * Creating event for analytics to track time range options clicks
   * @param eventName event name
   * @param optionId option which has been selected
   */
    private createEvent(eventName: string, optionId: string) {
      const country = this.sessionService.userCountry;
      const customer = this.sessionService.customerDetail;
      const event = {
        event: eventName,
        customerCode: customer.customerCode,
        customerName: customer.customerDesc,
        country: country,
        optionId: optionId
      };
      return event;
    }
}
